<script lang="ts">
    export let title;
</script>

<div class="relative hidden flex-col justify-center gap-y-1 text-center font-Roboto text-white desktop:flex">
    <h5 class="text-base pointer-events-none absolute inset-0 -top-6 font-bold uppercase">{title}</h5>
    <div class="text-base block w-full min-w-[250px] rounded-full border border-black bg-black/60"><slot /></div>
</div>
